<template>
  <div
    class="header"
    :class="{
      security: security,
      isKeyPal: isKeyPal,
      'keypal-detail': isKeyPalDetail,
      'safe-box': isSafeBox,
      'keypal-card': isKeyPalCard,
      'menu-bg': isMenuMobile,
    }"
  >
    <div class="content d-flex ai-center jc-between">
      <img class="logo" :src="logoImg" @click="goHome" />
      <div
        v-if="$route.path !== '/keypal-card-instructions'"
        class="nav-wrap d-flex ai-center jc-between flex-1"
      >
        <!-- :class="{ 'safe-box': isSafeBox }" -->
        <!-- v-if="!isSafeBox" -->
        <div class="nav-item-wrap d-flex ai-center">
          <div
            class="nav-item"
            v-for="(navItem, navIndex) in navList"
            :key="navIndex"
            @click="onNavItem(navItem)"
            @mouseenter="onMouseenter(navItem, navIndex)"
            @mouseleave="onMouseleave"
          >
            <div class="text title">
              <div class="title" :class="{ security: security }">
                {{ navItem.title }}
              </div>
            </div>
            <!-- <img class="arrow" v-if="navItem.child" :src="arrowImg" /> -->
          </div>
        </div>
        <div class="nav-item-wrap">
          <div
            class="nav-item nav-item-dark"
            v-if="$route.path === '/' || $route.meta.showThemeSwitch"
            @click="switchMode"
          >
            <img
              v-if="isDarkMode"
              src="../../assets/images/header/mode-dark.png"
              alt=""
            />
            <img v-else src="../../assets/images/header/mode.png" alt="" />
          </div>
          <!-- 语言栏 -->
          <div
            class="nav-item nav-item-lang"
            :class="{ security: security }"
            @mouseenter="showLanguage = true"
            @mouseleave="showLanguage = false"
          >
            <!-- <div class="text title" :class="{ security: security }">
              {{ langLabel }}
            </div> -->
            <div class="language-title">
              <img :src="languageImg" alt="" />
              <span>{{ langLabel }}</span>
            </div>
            <LanguageBox v-if="showLanguage" :langData="langData" />
          </div>
        </div>
      </div>
      <div class="menu-wrap">
        <img class="shop" :src="shopImg" @click="goShoppingCart" alt="" />
        <img class="menu" :src="currentMenuImg" @click="onMenu" />
      </div>
    </div>
    <div class="navbar-wrap-child-container" :class="{ show: isShow }">
      <div
        class="navbar-wrap-child-content-wrap"
        :class="{ 'ani-down': isShow }"
        @mouseenter="onMouseenter(false)"
        @mouseleave="onMouseleave"
        :data-isOpen="isOpen"
      >
        <div class="navbar-wrap-child-content">
          <div class="navbar-wrap-child-left">
            <div
              class="navbar-wrap-child-item"
              :class="{ show: navIndex === nIndex && isOpen === 'true' }"
              v-for="(navItem, nIndex) in navList"
              :key="nIndex"
            >
              <div
                class="nav-children-item"
                :class="{
                  'ani-scale':
                    navItem.aniScale || (navItem.forBusiness && cIndex > 1),
                }"
                v-for="(cItem, cIndex) in navItem.child"
                @click="navChildrenGo(cItem, $event)"
                @mouseenter="childMouseenter(cItem, cIndex)"
                @mouseleave="childMouseleave"
                :key="cIndex"
              >
                <template v-if="navItem.product">
                  <img
                    class="ani-scale"
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.icon"
                    alt=""
                  />
                  <div class="label" v-if="cItem.label">
                    <span>{{ cItem.label }}</span>
                    <img
                      v-if="cItem.KeyPal_2"
                      src="../../assets/images/keypal-two/two.png"
                      alt=""
                    />
                  </div>
                </template>
                <template v-if="navItem.learn">
                  <img
                    v-if="childrenIndex === cIndex"
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.activeIcon"
                    alt=""
                  />
                  <img
                    v-else
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.icon"
                    alt=""
                  />
                  <div
                    class="nav-children-item-label learn-label"
                    :class="{ active: childrenIndex === cIndex }"
                    v-if="cItem.label"
                  >
                    <div class="label">{{ cItem.label }}</div>
                    <div class="tutorials">
                      <span :class="{ active: childrenIndex === cIndex }">
                        {{
                          cIndex === 0
                            ? $t('common.information')
                            : $t('common.tutorials')
                        }}
                      </span>
                      <img
                        v-if="childrenIndex === cIndex"
                        src="../../assets/images/header/learn/arrow-dark.png"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/images/header/learn/arrow.png"
                        alt=""
                      />
                    </div>
                  </div>
                </template>
                <template v-if="navItem.apps">
                  <img
                    v-if="childrenIndex === cIndex"
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.activeIcon"
                    alt=""
                  />
                  <img
                    v-else
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.icon"
                    alt=""
                  />
                  <div
                    class="nav-children-item-label apps-label"
                    v-if="cItem.label"
                    :class="{
                      active: childrenIndex === cIndex,
                      'top-zh':
                        $i18n.locale === 'zh' || $i18n.locale === 'zh-tw',
                    }"
                  >
                    <div class="label">{{ cItem.label }}</div>
                    <div class="desc" v-if="cIndex === 2">
                      {{ $t('common.comingSoon') }}
                    </div>
                  </div>
                </template>
                <template v-if="navItem.forBusiness">
                  <img
                    v-if="childrenIndex === cIndex && cItem.activeIcon"
                    :style="{ cursor: 'default' }"
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.activeIcon"
                    alt=""
                  />
                  <img
                    v-else-if="cItem.icon"
                    :style="{ cursor: 'default' }"
                    :class="{ 'product-img': navItem.product }"
                    :src="cItem.icon"
                    alt=""
                  />
                  <div class="child-text" v-else>{{ $t('common.cases') }}</div>
                  <div
                    class="nav-children-item-label business-label"
                    :class="{ active: childrenIndex === cIndex }"
                    v-if="cItem.label"
                  >
                    <div class="label" :class="{ 'label-white': cIndex === 0 }">
                      {{ cItem.label }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="navbar-wrap-child-right">
            <div
              class="button shopping-cart"
              v-if="navIndex === 0"
              @click="goShoppingCart"
            >
              <img :src="shoppingCartImg" alt="" />
              <span>{{ $t('common.goShoppingCart') }}</span>
              <img class="enter" :src="enterImg" alt="" />
            </div>
            <!-- <div
              class="button learn-more"
              v-if="navIndex === 1 || navIndex === 2"
            >
              <span>{{ $t('common.learnMore') }}</span>
              <img class="enter" :src="enterImg" alt="" />
            </div> -->
            <div class="business" v-if="navIndex === 3">
              <div class="contact-us">
                <div class="contact-title">{{ $t('common.contactUs') }}</div>
                <div class="contact-item">
                  <img :src="emailImg" alt="" />
                  <a href="mailto:support@keypal.pro" target="_blank">
                    support@keypal.pro
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MenuMobile v-if="isMenuMobile" @close="closeMenuMobile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuMobile from '../common/MenuMobile.vue';
import LanguageBox from '../common/LanguageBox.vue';
import buyCardLink from '../../mixins/buyCardLink';
import { setMode } from '../../utils';
import navUrl from '../../mixins/navUrl';

export default {
  props: {
    security: {
      type: Boolean,
    },
    isKeyPalCard: {
      type: Boolean,
    },
    isKeyPal: {
      type: Boolean,
    },
    isSafeBox: {
      type: Boolean,
    },
    isKeyPalDetail: {
      type: Boolean,
    },
  },
  components: { MenuMobile, LanguageBox },
  data() {
    return {
      isMenuMobile: false,
      offspringIndex: undefined,
      isOffspring: false,
      isOpen: false,
      navIndex: '',
      showLanguage: false,
      childrenIndex: '',
    };
  },
  mixins: [buyCardLink, navUrl],
  computed: {
    ...mapGetters(['isDarkMode']),
    isZh() {
      return this.$i18n.locale === 'zh';
    },
    shopImg() {
      return require(`../../assets/images/header/shop${this.darkModeImg}.png`);
    },
    languageImg() {
      return require(`../../assets/images/header/language${this.darkModeImg}.png`);
      // if (this.$route.path === '/') {
      //   return require(`../../assets/images/header/language${this.darkModeImg}.png`);
      // }
      // return require('../../assets/images/header/language-dark.png');
    },
    currentNav() {
      if (this.navIndex !== '' && this.navList[this.navIndex].child) {
        return this.navList[this.navIndex];
      } else {
        return null;
      }
    },
    isShow() {
      return this.isOpen === 'true' && this.currentNav;
    },
    shoppingCartImg() {
      return require(`../../assets/images/header/Shopping-Cart${this.darkModeImg}.png`);
    },
    enterImg() {
      return require(`../../assets/images/header/enter${this.darkModeImg}.png`);
    },
    emailImg() {
      return require(`../../assets/images/header/For-Business/email${this.darkModeImg}.png`);
    },
    menuImg() {
      if (this.security) {
        return require('../../assets/images/security/more-w.png');
      } else {
        return require(`../../assets/images/home/menu${this.darkModeImg}.png`);
      }
    },
    menuCloseIg() {
      return require(`../../assets/images/home/menu-close${this.darkModeImg}.png`);
    },
    currentMenuImg() {
      if (this.isMenuMobile) {
        return this.menuCloseIg;
      } else {
        return this.menuImg;
      }
    },
    logoImg() {
      if (this.security) {
        return require('../../assets/images/home/logo-dark.png');
      } else {
        return require(`../../assets/images/home/logo${this.darkModeImg}.png`);
      }
      // if (this.security) {
      //   return require('../../assets/images/home/logo-dark.svg');
      // } else {
      //   return require(`../../assets/images/home/logo${this.darkModeImg}.svg`);
      // }
    },
    arrowImg() {
      if (this.security) {
        return require('../../assets/images/home/arrow-w.png');
      } else {
        return require('../../assets/images/home/arrow.png');
      }
    },

    navList() {
      return [
        {
          title: this.$t('common.product'),
          product: true,
          child: [
            {
              icon: require(`../../assets/images/header/KeyPal-2.png`),
              KeyPal_2: true,
              label: this.$t('navigation.product.label_1'),
              routePath: '/',
            },
            {
              icon: require(`../../assets/images/header/KeyPal-plus.png`),
              label: 'KeyPal Plus',
              // routePath: '/keypalplus',
              url: location.origin + '/#/keypalplus',
            },
            {
              icon: require(`../../assets/images/header/Secret-Box.png`),
              label: this.$t('common.secretBox'),
              // routePath: '/safebox',
              url: location.origin + '/#/safebox',
            },
            {
              icon: require(`../../assets/images/header/KeyPal-Card.png`),
              label: 'KeyPal Card',
              url: `https://card.keypal.pro/`,
            },
          ],
        },
        {
          title: this.$t('common.learn'),
          learn: true,
          aniScale: true,
          child: [
            {
              icon: require(`../../assets/images/header/learn/learn-1${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/learn/learn-1-on.png`),
              label: this.$t('navigation.learn.label_1'),
              // routePath: '/security',
              url: location.origin + '/#security',
            },
            {
              icon: require(`../../assets/images/header/learn/learn-2${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/learn/learn-2-on.png`),
              label: 'KeyPal 2',
              routePath: `/keypal2/tutorial`,
            },
            {
              icon: require(`../../assets/images/header/learn/learn-3${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/learn/learn-3-on.png`),
              label: 'KeyPal Plus',
              // routePath: '/academy',
              url: location.origin + '/#academy',
            },
            {
              icon: require(`../../assets/images/header/learn/learn-4${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/learn/learn-4-on.png`),
              label: 'KeyPal Card',
              url: `https://card.keypal.pro/tutorials?locale=${this.$i18n.locale}`,
            },
          ],
        },
        {
          title: this.$t('common.apps'),
          apps: true,
          aniScale: true,
          child: [
            {
              icon: require(`../../assets/images/header/apps/app-1${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/apps/app-1-on.png`),
              label: this.$t('common.mobileWallet'),
              url: `https://tokenpocket.pro/`,
            },
            {
              icon: require(`../../assets/images/header/apps/app-2${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/apps/app-2-on.png`),
              label: this.$t('common.extensionWallet'),
              url: this.extensionUrl,
            },
            {
              icon: require(`../../assets/images/header/apps/app-3${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/apps/app-3-on.png`),
              label: this.$t('common.KeyPal_2_firmware'),
              // label: this.$t('common.comingSoon'),
              // routePath: '/firmwareupgrade',
            },
            {
              icon: require(`../../assets/images/header/apps/app-4${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/apps/app-4-on.png`),
              // local: true,
              label: this.$t('common.KeyPal_Plus_firmware'),
              // routePath: '/firmwareupgrade',
              url: location.origin + '/#/firmwareupgrade',
            },
          ],
        },
        {
          title: this.$t('common.forBusiness'),
          forBusiness: true,
          child: [
            {
              label: this.$t('common.cooperationSolution'),
              icon: require(`../../assets/images/header/For-Business/1-on.png`),
            },
            {
              text: true,
            },
            {
              // label: 'KeyPal x TRON',
              label: this.$t('common.comingSoon'),
              icon: require(`../../assets/images/header/For-Business/2${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/For-Business/2-on.png`),
              // local: true,
              // routePath: '/keypalplus',
            },
            {
              // label: 'KeyPal x GoPlus',
              label: this.$t('common.comingSoon'),
              icon: require(`../../assets/images/header/For-Business/3${this.darkModeImg}.png`),
              activeIcon: require(`../../assets/images/header/For-Business/3-on.png`),
              // local: true,
              // routePath: '/keypalplus',
            },
          ],
        },
        {
          title: this.$t('common.support'),
          url: this.supportUrl,
        },
      ];
    },
    langData() {
      return {
        title: this.$t('common.language'),
        lang: true,
        child: [
          { label: 'English', lang: 'en' },
          { label: '中文(简体)', lang: 'zh' },
          { label: '中文(繁体)', lang: 'zh-tw' },
          { label: '日本語', lang: 'ja' },
          { label: '한국어', lang: 'ko' },
          { label: 'Français', lang: 'fr' },
          { label: 'Español', lang: 'es' },
        ],
      };
    },
    langLabel() {
      let lang = this.$i18n.locale;
      switch (lang) {
        case 'zh':
          return '中文(简体)';
        case 'zh-tw':
          return '中文(繁体)';
        case 'en':
          return 'English';
        case 'ja':
          return '日本語';
        case 'ko':
          return '한국어';
        case 'fr':
          return 'Français';
        case 'es':
          return 'Español';
        default:
          return '中文(简体)';
      }
    },
  },
  // watch: {
  //   isShow(newVal) {
  //     console.log('isShow changed:', newVal);
  //   },
  // },
  mounted() {
    document.body.style.overflow = 'auto';
  },
  methods: {
    childMouseenter(cItem, index) {
      // console.log('childMouseenter', cItem, index);
      this.childrenIndex = index;
    },
    childMouseleave() {
      this.childrenIndex = '';
    },
    switchMode() {
      this.$store.commit('setDark', !this.isDarkMode);
      setMode(this.isDarkMode);
      localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
    },
    goShoppingCart() {
      let url = `https://keypal.store/`;
      if (this.isZh) {
        url = `https://j.youzan.com/o5Rh1B`;
      }
      window.open(url, '_blank');
    },
    onMouseenter(item, index) {
      // console.log('onMouseenter', item)
      if (item) {
        this.navIndex = index;
      }
      this.isOpen = 'true';
      // console.log('enter-navIndex', this.navIndex);
    },
    onMouseleave() {
      // console.log('onMouseleave')
      this.isOpen = 'false';
      // this.isOpen = 'true'
      // console.log('leave-navIndex', this.navIndex);
    },
    navChildrenGo(item, el) {
      // console.log(item)
      if (item.url && !item.local) {
        window.open(item.url, '_blank');
      } else if (item.routePath) {
        this.$router.push({ path: item.routePath });
      }
      this.navIndex = '';
    },
    onMenu() {
      this.isMenuMobile = !this.isMenuMobile;
      if (this.isMenuMobile) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
    closeMenuMobile() {
      this.isMenuMobile = false;
      document.body.style.overflow = 'auto';
    },
    onNavItem(item) {
      if (item.routePath) {
        this.$router.push({ path: item.routePath });
      }
      if (item.url) {
        window.open(item.url, '_blank');
      }
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 9997;
  width: 100vw;
  background: var(--bg-1);
  padding: 5px 0;
  &.safe-box {
    // position: absolute;
    width: -webkit-fill-available;
    width: -moz-available; //火狐浏览器
    background: #fff;
  }
  &.security {
    background: #101010;
  }
  &.keypal-card {
    background: #000000;
  }
  &.isKeyPal {
    background: #fff;
  }
  .logo {
    width: 111px;
    height: 26px;
    cursor: pointer;
  }
  .nav-wrap {
    &.safe-box {
      justify-content: flex-end;
    }
    .nav-item-wrap {
      margin-left: 32px;
      display: flex;
      align-items: center;
      .nav-item {
        height: 50px;
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 16px;
        cursor: pointer;
        .title {
          font-size: 16px;
          font-family: Inter-Regular;
          color: var(--color-1);
          font-weight: 400;
          &.security {
            color: #fff;
          }
        }
        .arrow {
          margin-left: 4px;
          width: 16px;
          transform-origin: center center;
          transform: rotate(0deg);
        }
        .nav-child-wrap {
          display: none;
          position: absolute;
          z-index: 999;
          top: 50px;
          left: -0.1px;
          // padding: 12px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);
          .left-wrap {
            padding: 12px;
            &.active {
              padding: 12px 0 12px 12px;
            }
          }
          .nav-child-item {
            padding: 7px 20px;
            &.active {
              background: #f5f5f5;
              border-radius: 12px;
            }
            &:nth-child(n + 2) {
              margin-top: 12px;
            }
            .icon {
              width: 24px;
            }
            .label-wrap {
              margin-left: 12px;
              .arrow-right {
                width: 12px;
                transform: translateX(14px);
              }
              span {
                white-space: nowrap;
                font-size: 13px;
                font-family: Inter-Regular;
                color: #101010;
              }
            }
          }
          .offspring-wrap {
            // display: none;
            // position: absolute;
            top: 0;
            right: -142px;
            background: #ffffff;
            border-radius: 0 12px 12px 0;
            height: inherit;
            .white-bg {
              height: 100%;
              padding: 12px;
              margin-left: 12px;
              border-radius: 12px;
              background: #fbfbfb;
              .offspring-item {
                padding: 7px 20px;
                &:nth-child(n + 2) {
                  margin-top: 12px;
                }
              }
              .offspring-item:hover {
                background: #f5f5f5;
                border-radius: 12px;
              }
              span {
                white-space: nowrap;
              }
            }
          }
          .nav-child-item:hover {
            background: #f5f5f5;
            border-radius: 12px;
            // .offspring-wrap {
            //   display: block;
            // }
          }
        }
      }
      .nav-item:hover {
        .nav-child-wrap {
          display: flex;
        }
        .arrow {
          transform: rotate(-180deg);
          transition: transform 0.3s;
        }
      }
      .nav-item-dark {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 22px;
          height: 22px;
        }
      }
      .nav-item-lang {
        min-width: 100px;
        height: 50px;
        // border: 0.0100px solid #101010;
        // border-radius: 50px;
        &.security {
          // border: 0.01px solid #fff;
          .language-title {
            span {
              color: #fff;
            }
          }
        }
        .language-title {
          display: flex;
          align-items: center;
          gap: 0 10px;
          cursor: pointer;
          span {
            font-size: 15px;
            font-weight: 500;
            color: var(--color-1);
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
        .nav-child-wrap-bg {
          display: none;
          padding-top: 0.1px;
          position: absolute;
          z-index: 999;
          left: 50%;
          transform: translateX(-50%);
          top: 40px;
          .nav-lang-child-wrap {
            border-radius: 12px;
            background: var(--navbar-wrap-child-language-bg);
            border: var(--navbar-wrap-child-language-border);
            box-shadow: 0 6px 16px 0 rgba(45, 54, 86, 0.05);
            position: static;
            padding: 24px;
            display: flex;
            flex-direction: column;
            gap: 24px 0;
            .nav-lang-child-item {
              span {
                font-size: 16px;
                white-space: nowrap;
                color: var(--color-1);
                &:hover {
                  color: #2980fe;
                }
              }
            }
          }
        }
      }
      .nav-item-lang:hover {
        .nav-child-wrap-bg {
          display: block;
        }
      }
    }
  }
  .keypal-card-buy {
    background: #2980fe;
    border-radius: 4px;
    padding: 13px 0.31px;
    margin: 2px 0;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-wrap {
    display: none;
  }

  .menu-mobile {
    display: none;
  }

  .content {
    position: relative;
    z-index: 10;
  }

  .navbar-wrap-child-container {
    width: 100%;
    height: 100vh;
    background: var(--navbar-wrap-child-container-bg);
    position: fixed;
    z-index: 5;
    left: 0;
    top: 0;
    visibility: hidden;
    opacity: 0;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    &.show {
      visibility: visible;
      opacity: 1;
    }
    .navbar-wrap-child-content-wrap {
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      background: var(--bg-1);
      height: 384px;
      transform: translateY(-400px);
      // transform: translateY(0px);
      .navbar-wrap-child-content {
        position: relative;
        max-width: 1200px;
        margin: 0 auto;
        // height: 100%;
        display: flex;
        justify-content: space-between;
        padding: 98px 0 0;

        .navbar-wrap-child-left {
          display: flex;
          .navbar-wrap-child-item {
            display: none;
            gap: 0 16px;
            .nav-children-item {
              width: 186px;
              height: 240px;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px 0;
              img {
                width: 186px;
                height: 240px;
                cursor: pointer;
              }
              .product-img {
                width: 150px;
                height: 168px;
              }
              .label {
                display: flex;
                align-items: center;
                gap: 0 4px;
                span {
                  font-size: 20px;
                  font-weight: 600;
                  text-align: center;
                  color: var(--color-1);
                }

                img {
                  width: 18px;
                  height: 18px;
                }
              }

              .child-text {
                width: 164px;
                margin-top: 32px;
                font-size: 16px;
                font-weight: 600;
                text-align: center;
                color: var(--color-1);
              }

              .nav-children-item-label {
                position: absolute;
                top: 154px;
                width: 100%;
                padding: 0 17px;

                &.active {
                  .label {
                    color: #ffffff;
                  }

                  .desc {
                    color: #ffffff;
                  }
                }

                &.top-zh {
                  top: 172px;
                }

                .label {
                  font-size: 20px;
                  font-weight: 600;
                  color: var(--color-1);

                  &.label-white {
                    color: #ffffff;
                  }
                }

                .tutorials {
                  margin-top: 4px;
                  display: flex;
                  align-items: center;
                  gap: 0 4px;
                  span {
                    font-size: 13px;
                    color: var(--color-1);
                    &.active {
                      color: #ffffff;
                    }
                  }
                  img {
                    width: 12px;
                    height: 13px;
                  }
                }

                .desc {
                  margin-top: 4px;
                  font-size: 13px;
                  color: var(--color-1);
                  &.active {
                    color: #ffffff;
                  }
                }
              }

              .learn-label {
                top: 170px;
              }

              .business-label {
                top: 170px;
              }
            }
          }
        }

        .navbar-wrap-child-right {
          display: flex;
          align-items: center;
          .button {
            display: flex;
            align-items: center;
            height: 60px;
            line-height: 60px;
            padding: 0 32px;
            background: #1d1d1f;
            border-radius: 41px;
            cursor: pointer;
            img {
              width: 28px;
              height: 28px;
            }
            .enter {
              width: 20px;
              height: 20px;
            }
            span {
              font-size: 16px;
              color: #fff;
            }
          }

          .business {
            height: 186px;
            border-left: 1px solid rgba(0, 0, 0, 0.15);
            display: flex;
            align-items: center;
            padding: 0 62px;
            .contact-us {
              font-size: 16px;
              font-weight: 600;
              color: var(--color-1);
              display: flex;
              flex-direction: column;
              gap: 16px 0;
              .contact-title {
              }

              .contact-item {
                display: flex;
                align-items: center;
                gap: 0 8px;
                img {
                  width: 20px;
                  height: 20px;
                }
                a {
                  color: var(--color-1);
                }
              }
            }
          }
        }
      }
      &.ani-down {
        transform: translateY(0px);
        .navbar-wrap-child-content {
          .navbar-wrap-child-item {
            &.show {
              display: flex;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .header {
    padding: 10px 0;

    &.menu-bg {
      background: var(--bg-7);
    }
    .nav-wrap {
      display: none;
    }

    .menu-wrap {
      display: flex;
      align-items: center;
      gap: 0 10px;
      .shop {
        width: 48px;
        height: 30px;
      }
      .menu {
        display: block;
        width: 28px;
        height: 28px;
      }
    }

    .menu-mobile {
      display: block;
    }
  }
}

@media screen and (max-width: 767px) {
  .header {
    &.keypal-detail {
      background: #f6f6f6;
    }
    .content {
      padding: 0 14px;
      justify-content: space-between;
    }
    .logo {
      // width: 119px;
      width: auto;
      height: 26px;
    }
    .nav-wrap {
      display: none;
    }
    .keypal-card-buy {
      display: none;
    }

    .menu-wrap {
      display: flex;
      align-items: center;
      gap: 0 10px;
      .shop {
        width: 48px;
        height: 30px;
      }
      .menu {
        display: block;
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>
